import * as Yup from "yup";
import { parseCurrencyString } from "@/utils/parseCurrencyString";

export const employeeSaleSchema = Yup.object().shape({
  user_id: Yup.number().required("Funcionário é obrigatório"),

  product: Yup.object()
    .shape({
      product_id: Yup.number()
        .transform((value, originalValue) =>
          originalValue === "" ? undefined : value,
        )
        .required("Produto é obrigatório")
        .integer("ID do produto deve ser um número"),

      quantity: Yup.number()
        .transform((value, originalValue) =>
          originalValue === "" ? undefined : value,
        )
        .required("Quantidade é obrigatória")
        .integer("Quantidade deve ser um número inteiro")
        .min(1, "A quantidade mínima é 1"),
    })
    .required("O produto é obrigatório"),

  due_date: Yup.string()
    .required("Data de vencimento é obrigatória")
    .matches(
      /^\d{4}-\d{2}-\d{2}$/,
      "Formato de data inválido (use YYYY-MM-DD)",
    ),

  total_price: Yup.string()
    .transform(parseCurrencyString)
    .test(
      "is-required",
      "Preço total é obrigatório",
      (value) => !!value && value !== "0" && value !== "0.00",
    )
    .test("is-valid", "Preço total deve ser maior que zero", (value) => {
      const numberValue = parseFloat(value ?? "0");
      return !isNaN(numberValue) && numberValue > 0;
    }),
});
